const t = {
  "icon-button": "icon-button",
  "icon-button--size-large": "icon-button--size-large",
  "icon-button--default": "icon-button--default",
  "icon-button--disabled": "icon-button--disabled",
  "icon-button--primary": "icon-button--primary",
  "icon-button--secondary": "icon-button--secondary",
  "icon-button--tertiary": "icon-button--tertiary",
  "icon-button--success": "icon-button--success",
  "icon-button--error": "icon-button--error"
};
export {
  t as default
};
